import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InspectionZCoefficientCase } from '@authority-labs/api-interfaces';
import { CheckBasicCaseComponent } from '../check-basic-case/check-basic-case.component';

@Component({
  selector: 'authority-labs-check-z-coefficient-case',
  templateUrl: './check-z-coefficient-case.component.html',
  styleUrls: ['./check-z-coefficient-case.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckZCoefficientCaseComponent extends CheckBasicCaseComponent {
  @Input() inspection: InspectionZCoefficientCase;
}
